<script setup>
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  resource: { type: Object, default: () => ({}) },
  submitLabel: { type: String, required: true },
});

const emit = defineEmits(['submit', 'cancel']);
const { t } = useI18n();

const state = reactive({
  name: '',
  description: '',
});

watch(
  () => props.resource,
  next => {
    state.name = next?.name || '';
    state.description = next?.description || '';
  },
  { immediate: true }
);
</script>

<template>
  <form
    class="flex flex-col gap-4"
    @submit.prevent="
      emit('submit', {
        name: state.name,
        description: state.description,
      })
    "
  >
    <Input
      v-model="state.name"
      :label="t('ARROWS_AI.RESOURCES.NAME')"
      :placeholder="t('ARROWS_AI.RESOURCES.NAME_PLACEHOLDER')"
    />
    <Input
      v-model="state.description"
      :label="t('ARROWS_AI.RESOURCES.DESCRIPTION_LABEL')"
      :placeholder="t('ARROWS_AI.RESOURCES.DESCRIPTION_PLACEHOLDER')"
    />
    <div class="flex items-center w-full gap-3">
      <Button
        type="button"
        variant="faded"
        color="slate"
        class="w-full bg-n-alpha-2 text-n-blue-11 hover:bg-n-alpha-3"
        :label="t('ARROWS_AI.CANCEL')"
        @click="emit('cancel')"
      />
      <Button type="submit" class="w-full" :label="submitLabel" />
    </div>
  </form>
</template>
